import {Injectable} from '@angular/core';
import { HttpService } from '../http/http.service'

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private test: HttpService) {}

  setStorage(key, value) {
    localStorage.setItem(key, value);
  }

  getStorage(key) {
    return localStorage.getItem(key);
  }
}
